import { render } from 'lit-html';
import { Haiku } from './lib/haiku.js';

render(Haiku(), document.getElementById('haiku-content'));
